import React, { Ref, useState } from 'react';
import { DropdownToggle, DropdownMenu, Dropdown } from 'reactstrap';
import RoomInput from './RoomInput';
import { cloneDeep, range, sumBy } from 'lodash';
import { RoomSearchInfo } from '@/__generated';
import { HOTEL_SEARCHBOX_CONFIG } from '@/config';

interface Props {
  rooms: RoomSearchInfo[];
  elmRef: Ref<{ close: Function; open: Function } | undefined>;
  onChange: (rooms: RoomSearchInfo[]) => void;
}

const GuestSearch = ({ elmRef, onChange, rooms }: Props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  React.useImperativeHandle(
    elmRef,
    () => {
      return {
        open() {
          setDropdownOpen(true);
        },
        close() {
          setDropdownOpen(false);
        },
      };
    },
    [],
  );

  const removeRoom = (roomIndex: number) => {
    let roomsClone = cloneDeep(rooms.filter((r, i) => i !== roomIndex));
    onChange(roomsClone);
  };

  const addRoom = () => {
    onChange([...rooms, cloneDeep(HOTEL_SEARCHBOX_CONFIG.defaultRoomValue)]);
  };

  const onRoomChange = (roomIndex: number, key: 'noOfAdult' | 'noOfChild' | 'childAges', value: any) => {
    let room = rooms[roomIndex];
    if (key === 'noOfChild') {
      if (value > (room.noOfChild || 0)) {
        range(0, value - (room.noOfChild || 0)).forEach(i => {
          room.childAges?.push(HOTEL_SEARCHBOX_CONFIG.defaultChildAge);
        });
      } else {
        room.childAges = room.childAges?.filter((_, i) => i < value);
      }
      room.noOfChild = value;
    } else {
      room[key] = value as any;
    }
    onChange(cloneDeep(rooms));
  };

  const toggle = () => {
    setDropdownOpen(x => !x);
  };
  const roomInfoText = React.useMemo(() => {
    const noRooms = rooms.length;
    const noAdults = sumBy(rooms, x => x.noOfAdult || 0);
    const noChildren = sumBy(rooms, x => x.noOfChild || 0);
    return `${noRooms} ${noRooms > 1 ? 'rooms' : 'room'} - ${noAdults} ${noAdults > 1 ? 'adults' : 'adult'} - ${noChildren} children`;
  }, [rooms]);

  return (
    <div className="searchMenu-guests px-30 xl:py-20 xl:px-0 js-form-dd js-form-counters position-relative rounded-0">
      <h4 className="text-15 fw-500 ls-2 lh-16">Guest</h4>
      <Dropdown tag="div" isOpen={dropdownOpen} toggle={toggle} className="text-15 text-light-1 ls-2 lh-16">
        <DropdownToggle tag="div">{roomInfoText}</DropdownToggle>
        <DropdownMenu tag="div" className="search-box-transition shadow-2 dropdown-menu min-width-400 mt-20 cursor-default">
          <div className="bg-white px-20 py-20 rounded-4 ">
            {rooms.map((room, index) => {
              return (
                <RoomInput
                  key={HOTEL_SEARCHBOX_CONFIG.__createRoomKey(index, room)}
                  onRoomChange={onRoomChange}
                  room={room}
                  roomIndex={index}
                  onRemoveRoom={removeRoom}
                />
              );
            })}
            {rooms.length < HOTEL_SEARCHBOX_CONFIG.maxRoom ? (
              <div className=" d-flex justify-content-end items-center">
                <button className="text-dark-4  py-10 text-14" onClick={addRoom}>
                  <i className="icon-plus text-12 mr-5" />
                  Add more rooms
                </button>
              </div>
            ) : null}
            <div className="text-14 fw-500 text-red-1">{HOTEL_SEARCHBOX_CONFIG.note}</div>
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
export default GuestSearch;
